export { default as BaseHeader } from './BaseHeader';
export { default as BaseFooter } from './BaseFooter';
export { default as BaseForm } from './BaseForm';
export { default as BaseFormWithPolling } from './BaseFormWithPolling';
export { default as BaseModel } from './BaseModel';
export { default as BaseView } from './BaseView';
export { addCustomButton, createCustomButtons, createIdpButtons } from './FormInputFactory';



// WEBPACK FOOTER //
// ./src/v2/view-builder/internals/index.js